import React, { useDebugValue, useState } from "react";
import EditFieldModal from "./EditFieldModal";
import "./FormCanvas.scss";
import { RiDeleteBin4Fill } from "react-icons/ri";
import { MdEditSquare } from "react-icons/md";
import { InputLabel, InputType, SelectBorder } from "../../../../../Global/GlobalFormElement";
import { useDispatch, useSelector } from "react-redux";
import { updateFieldMinMax } from "../../../../../Redux/Users/action";

const FormCanvas = ({ fields, updateField, removeField, onGenerateSchema, titleValue, descriptionValue, updateTitleAndDescription }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentField, setCurrentField] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [categories, setCategories] = useState([])
  
  const openModal = (field) => {
    setCurrentField(field);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentField(null);
  };


  const handleSave = (updatedData) => {
    const updatedFields = fields.map((field) => {
      if (field.dataName === updatedData.dataName) {
        if (field.fields) {
          const updatedSubFields = field.fields.map((subField) => {
            const myField = updatedData.fields[0]
            console.log(subField.dataName, myField.dataName, "111")
            if (subField.dataName === myField.dataName) {
              return {
                ...subField,
                value: myField.value || subField.value,
                minValue: myField.minValue || subField.minValue, 
                maxValue: myField.maxValue || subField.maxValue, 
              };
            }
            return subField;
          });
  
          return {
            ...field,
            fields: updatedSubFields,
          };
        }
        return {
          ...updatedData,
          minValue: updatedData.minValue || field.minValue, 
          maxValue: updatedData.maxValue || field.maxValue, 
        };
      }
  
      return field;
    });
  
    console.log(updatedFields, "updated fields after update");
    updateField(updatedFields); // Update the fields array with the new values
    closeModal(); // Close the modal after saving
  };
  


  const generateJSONSchema = () => {
    return fields.map((field, index) => {
      const fieldSchema = {
        label: field.label,
        type: field.type,
        criteria: field.criteria || "min/max criteria",
        index: index + 1,
        value: field.value || "",
        fields: field.fields
          ? field.fields.map((subField) => {
              if (subField.label === "Title" && field.label === "Title & Description") {
                subField.value = titleValue; // Assuming titleValue is defined somewhere in your component
              } else if (subField.label === "Description" && field.label === "Title & Description") {
                subField.value = descriptionValue; // Assuming descriptionValue is defined somewhere in your component
              }
  
              return {
                label: subField.label,
                type: subField.type,
                placeholder: subField.placeholder,
                fieldSize: subField.fieldSize,
                value: subField.value || "",
                minValue: subField.minValue || "", // Include minValue in the schema
                maxValue: subField.maxValue || "", // Include maxValue in the schema
              };
            })
          : [],
      };
  
      if (field.label === "Title & Description") {
        fieldSchema.fields[0].value = titleValue;
        fieldSchema.fields[1].value = descriptionValue;
      }
  
      return fieldSchema;
    });
  };
  
  const handleGenerateSchema = () => {
    const schema = generateJSONSchema();
    onGenerateSchema(schema);
  };

  return (
    <div className="form-canvass">
      {fields.length > 0 ? (
        fields.map((field, index) => (
          <div
            key={field.dataName}
            className="field-containerr"

          >
            <div className="field-input-containerr">
              <InputLabel
                style={{ "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center" }}
              >
                {"Criteria " + (index + 1)}
              </InputLabel>

              {field.fields ? (
                <div className="title-description-groupp">
                  {field.fields.map((subField, subIndex) => (
                    <div key={`${subField.dataName}-${subIndex}`} className="subb-field">
                      <InputLabel
                        style={{ "textAlign": "center" }}
                      >
                        {"Criteria " + subField.label}
                      </InputLabel>

                      <InputType
                        type={subField.type}
                        placeholder={subField.placeholder}
                        value={subField.value || ""}
                        onChange={(e) => {
                          const updatedFields = [...fields]; 
                          const updatedSubFields = updatedFields[index].fields.map((field) =>
                            field.dataName === subField.dataName
                              ? { ...field, value: e.target.value } 
                              : field
                          );

                          updatedFields[index] = {
                            ...updatedFields[index],
                            fields: updatedSubFields,
                          };

                          updateField(updatedFields); 
                        }}
                      />

                      {subField.required && !subField.value && (
                        <span style={{ color: "red" }}>This field is required.</span>
                      )}

                    </div>
                  ))}
                </div>
              ) : (
                <InputType
                  type={field.type}
                  placeholder={field.placeholder}
                  style={{ width: field.fieldSize }}
                />
              )}
            </div>


            <div className="field-actionss">
              <MdEditSquare className="form_canvass_icon" onClick={() => openModal(field)} />
              <RiDeleteBin4Fill className="form_canvass_icon" onClick={() => removeField(index)} />
            </div>
          </div>
        ))
      ) : (
        <div>No fields available. Please add some fields.</div>
      )}

      {isModalOpen && currentField && (
        <EditFieldModal field={currentField} onSave={handleSave} onClose={closeModal} />
      )}

      {/* Button to generate and pass the schema */}
      {/* <button onClick={handleGenerateSchema}>Generate JSON Schema</button> */}
    </div>
  );
};

export default FormCanvas;
